import { Box, Text } from "@chakra-ui/react";
import { Info } from "components/SvgIcons/icons/info";
import React from "react";
import { space } from "theme/themeConfig";
import { colours } from "@shared/ui.design-system";

export const BonusDayBanner: React.FC = () => {
  return (
    <Box
      backgroundColor={colours.accent.light}
      borderLeft={`5px solid ${colours.accent.strong}`}
      px={1}
      pt={space[-4]}
      pb={1}
      data-testid="bonus-day-banner"
      mt={1}
    >
      <Box display="flex" alignItems="flex-end">
        <Text
          width="95%"
          as="span"
          variant="acuminCapsM1"
          mt={0}
          letterSpacing="0.01rem"
          justifyContent="left"
        >
          FREE SPENDING LIMIT
        </Text>
        <Box width="5%">
          <Info w="22px" h="22px" />
        </Box>
      </Box>
      <Text
        variant="bookM1"
        letterSpacing="0.01rem"
        mt={space[-3]}
        lineHeight={{ base: space[1.5], md: space[1] }}
      >
        Buy one of these products without using any of your Spending Limit.
      </Text>
    </Box>
  );
};
